"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorCodes = {
  emailTaken: {
    message: "Email has already been taken"
  }
};